import { CASH_FLOW_MODULE_URL } from "src/modules/sales/modules/cash-flow/constant/contact.module-config";

export const CASH_OUT_TAG_MODULE_NAME = "Thẻ phiếu chi";
export const CASH_OUT_TAG_MODULE_URL = CASH_FLOW_MODULE_URL + "/cash-out-tag";
export const CASH_OUT_TAG_API_PATH = "/v1/cash-out-tag";
